import { getUsersNames } from '@/rest/users'
import getLocalizedName from '@/utils/getLocalizedName'
import i18n from '@/lang'
import store from '@/store/index.js'

const promiseCache = new Map()

export default {
  state: () => ({
    names: {}
  }),
  getters: {
    userById: state => id => {
      if (!id) {
        return 'NULL'
      }
      if (id === -1) {
        return i18n.global.t('common.system')
      }
      if (!Object.hasOwn(state.names, id)) {
        store.dispatch('loadUserNames', [id])
      }
      return getLocalizedName(state.names[id])
    }
  },
  mutations: {
    updateUsersNames (state, payload) {
      for (const key of Object.keys(payload)) {
        state.names[key] = payload[key]
      }
    },
    clearUserNames (state) {
      state.names = {}
    }
  },
  actions: {
    async loadUserNames ({ commit, state }, ids) {
      if (!ids?.length) {
        return
      }

      const missingIds = ids.filter(id => !Object.hasOwn(state.names, id))
      if (!missingIds.length) {
        return
      }

      const idsToFetch = []
      const promisesToAwait = []

      missingIds.forEach(id => {
        promiseCache.has(id)
          ? promisesToAwait.push(promiseCache.get(id))
          : idsToFetch.push(id)
      })

      if (idsToFetch.length) {
        const requestPromise = getUsersNames(idsToFetch)
          .then(data => {
            commit('updateUsersNames', data)
            return data
          })
          .finally(() => {
            idsToFetch.forEach(id => promiseCache.delete(id))
          })

        idsToFetch.forEach(id => promiseCache.set(id, requestPromise))
        promisesToAwait.push(requestPromise)
      }

      await Promise.all(promisesToAwait)
    },
    initialize ({ commit, rootGetters }) {
      if (!rootGetters.isAuthorized) {
        return
      }

      commit('clearUserNames')
      import.meta.env.DEV && console.log('initialized store – users')
    }
  }
}
